<template>
  <div class="statusTemplate">
    <!-- <div class="statusTemplate-header">评价</div> -->
    <div class="statusTemplate-content">
      <img
        class="statusTemplate-content-photo"
        :src="imgSrc"
        alt=""
      >
      <p class="statusTemplate-content-status">{{info}}</p>
      <p class="statusTemplate-content-text">{{text}}</p>
      <p
        class="statusTemplate-content-text"
        v-if="successText"
      >{{successText}}</p>
    </div>
  </div>
</template>
<script>
import '@/backend/styles/evaluate/base.scss';

export default {
  props: ['status'],
  data() {
    return {
      imgSrc: '',
      info: '',
      text: '',
      successText: '',
      appId: false
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (from.name === null) {
        vm.refresh(to, from)
      }
    })
  },
  methods: {
    refresh(to, form) {
      // if (to.query.status == 5) {
      //   this.$router.push({
      //     name: 'index',
      //     query: { id: localStorage.getItem('id') }
      //   })
      // }
    }
  },
  mounted() {
    // this.appId = this.$route.query.appId
    // if (!this.appId) {
    //   history.pushState(null, null, document.URL)
    //   window.addEventListener('popstate', function() {
    //     history.pushState(null, null, document.URL)
    //   })
    // }

    let value = Number(this.$route.query.status)

    switch (value) {
      case 0: // 待评价
        break
      case 1: // 已评价
        this.imgSrc = require('@/assets/yetEvaluation.png')
        this.info = '您已完成评价'
        this.text = '天擎天拓集团感谢您的宝贵反馈'
        break
      case 2: // 已失效
        this.imgSrc = require('@/assets/failure.png')
        this.info = '对不起，评价已失效'
        break
      case 6: // 评价成功
        this.imgSrc = require('@/assets/success.png')
        this.info = '评价成功'
        this.text = '尊敬的客户，感谢您的评价'
        this.successText = '您的宝贵意见将成为我们进步的助力，祝您生活愉快。'
        break
      default:
        this.imgSrc = require('@/assets/abnormal.png')
        this.info = '加载异常'
        this.text = '您好加载异常请刷新'
        break
    }
  }
}
</script>
<style lang="scss" scoped>
.statusTemplate {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #fff;
  &-header {
    width: 100%;
    height: 1.173rem;
    background: #3da1ff;
    box-shadow: 0px 1px 0px 0px rgba(0, 0, 0, 0.25);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: 0.48rem;
    font-weight: 600;
  }
  &-content {
    width: 100%;
    padding: 0.4rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    &-photo {
      width: 3.867rem;
      height: 3.733rem;
      margin-top: 1.467rem;
    }
    &-status {
      margin-top: 0.267rem;
      color: #3da1ff;
      font-size: 0.427rem;
    }
    &-text {
      margin-top: 0.64rem;
      color: #333;
      font-size: 0.347rem;
    }
  }
}
</style>
